module.exports = __webpack_public_path__ + "img/MVT_3934.2a5c86a9.jpg";